import React from "react";
import { AppFieldWithLabelAndError } from "./AppTypography";

const AppTextArea = ({
  label,
  value,
  rows = 3,
  onInput,
  placeholder,
  disabled = false,
  required = false,
  error,
  showCount = false,
  mandatory = false,
  maxLength,
  onChange,
  ...restProps
}) => {
  return (
    <AppFieldWithLabelAndError label={label} required={required || mandatory} error={error}>
      <div
        className={`flex items-center gap-3 rounded-xl border px-4 py-3
        ${
          disabled
            ? "bg-gray-50 border-gray-200"
            : "bg-white border-gray-300 focus-within:border-blue-500"
        } ${error ? "border-red-500" : ""}
            
            `}
      >
        <textarea
          rows={rows}
          value={value ?? ""}
          onInput={onInput}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          {...restProps}
          className={`
    flex-1 bg-transparent text-sm text-gray-700
    placeholder-gray-400
    outline-none ring-0 border-none
    focus:outline-none focus:ring-0 focus:border-transparent
    focus-visible:outline-none focus-visible:ring-0
    active:outline-none active:ring-0
    ${restProps.className || ""}
  `}
        />
      </div>
      {showCount && (
        <div className="w-full flex items-center gap-3 justify-end">
          <label className="text-14px text-gray-400">
            {`${value?.length || 0} / ${maxLength}`}
          </label>
        </div>
      )}
    </AppFieldWithLabelAndError>
  );
};

export default AppTextArea;
